import { useMemo } from 'react'
import { getS3ImageFilePath } from 'src/v3/utilities/image-upload'
import { getMigrationStatus } from '../utils/migration-status'
import { CREATE_COURSE_URLS } from '../../constants'
import { LightweightCourseV5 } from '../types'

export function useCourseDisplay(course: LightweightCourseV5) {
  let thumbnailUrl = useMemo(
    () => (course.thumbnail ? getS3ImageFilePath(course.thumbnail) : undefined),
    [course.thumbnail],
  )

  let migrationStatus = useMemo(
    () => getMigrationStatus(course, course.classCount),
    [course, course.classCount],
  )

  let navigationUrl = useMemo(() => {
    let isNotMigratable = course.classCount > 1
    return isNotMigratable
      ? `${CREATE_COURSE_URLS.V4INDEX}/${course.id}`
      : `${CREATE_COURSE_URLS.INDEX}/${course.id}/edit`
  }, [course.id, course.classCount])

  let isNotMigratable = course.classCount > 1

  return { thumbnailUrl, migrationStatus, navigationUrl, isNotMigratable }
}
